import { validateApiResponseWithZod } from '@nw/shared/utils';

import {
  BrandingSectionType,
  ClientConfigDetailType,
  ClientConfigThemeType,
  LoginCardConfigType,
  LoginSectionType
} from '../../../types/ClientConfigDetailTypes';
import { ClientConfigDetailSchema } from '../../../types/Schemas.zod';

import { ClientConfigDetailDTO } from '../../dtos/clientConfigDetailsDTO';

export const getClientConfigDetailTransformer = (
  data: ClientConfigDetailType
): ClientConfigDetailDTO => {
  const validateResponse = validateApiResponseWithZod(
    data,
    ClientConfigDetailSchema
  ) as ClientConfigDetailType;

  const {
    client_id,
    login_page: {
      layout: { type: layout_type },
      login_section_config,
      branding_section_config,
      theme
    }
  } = validateResponse;

  const loginSectionConfig: LoginSectionType = JSON.parse(login_section_config);

  const brandingSectionConfig: BrandingSectionType = JSON.parse(
    branding_section_config
  );
  const phoneNumberCardConfig: LoginCardConfigType | undefined =
    loginSectionConfig.phone_number_card_config;
  const otpCardConfig: LoginCardConfigType | undefined =
    loginSectionConfig.otp_card_config;

  const themeConfig: ClientConfigThemeType = JSON.parse(theme);

  return {
    clientId: client_id,
    layOutType: layout_type,
    brandingSectionMarkdownContent:
      brandingSectionConfig.branding_section_markdown_content,
    customStyles: themeConfig.custom_styles,
    fontFamilyType: themeConfig.font_family_type,
    headerImgUrl: loginSectionConfig.header_img_url ?? '',
    footerImgUrl: loginSectionConfig.footer_img_url ?? '',
    troubleLoggingIframeUrl:
      loginSectionConfig.trouble_logging_iframe_url ?? '',
    seoLink: brandingSectionConfig.seo_info?.link ?? [],
    seoMetaData: brandingSectionConfig.seo_info?.metaData ?? [],
    seoTitle: brandingSectionConfig.seo_info?.title ?? '',
    phoneNumberCardConfig,
    otpCardConfig,
    headerImgAltText: loginSectionConfig.header_logo_alt_text
  };
};
